
















import Vue from "vue";
import { Component } from "vue-property-decorator"
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { headerState } from "../../stores/header";
import { footerState } from "../../stores/footer";

@Component({})
export default class NotFound extends Vue {

  created() {
    footerState.setFooterDefault()
  }
}
